import React, { useState, useEffect, useRef, useContext } from "react";
import { StoreContext } from "../../store";
import './index.css';

import Slider from 'react-slick';

import ServiceCharacter from '../../assets/landing-page/service-gem.svg';
import ServiceGem from '../../assets/landing-page/service-character.svg';
import WalkingTimeDistance from '../../assets/landing-page/walking-time-distance.svg';
import WalkingTimeDistance2 from '../../assets/landing-page/walking-time-distance-2.png';
import { ReactComponent as MeasureArrow } from '../../assets/landing-page/wwm/arrow.svg';

import { scrollToTop } from "../../services";
import { debounce } from "../../services";
import { measureSlideData } from "../../constants";


const TwentyMinuteCity = () => {
  const { navigate, state } = useContext(StoreContext);
  const { isMobile } = state;
  let measureSliderRef = useRef(null);
  const [measureTab, setMeasureTab] = useState(0);

  const planningSteps = [
    {
      number: "01",
      title: "Count what counts",
      description:
        "Inventories of the natural, built, economic, and socio-cultural environment via computer vision and advanced data gathering techniques.",
      section: "white",
    },
    {
      number: "02",
      title: "Perception Survey",
      description:
        "Identify the cognitive, affective, physical, and experiential perceptions of residents about their community.",
      section: "white",
    },
    {
      number: "03",
      title: "Aspirations Survey",
      description:
        "Determine resident unique aspirations and sense of place.",
      section: "white",
    },
    {
      number: "04",
      title: "Placemaking",
      description:
        "Alternatives analyses reflecting community aspirations, sense of place, sustainability, and technology solutions.",
      section: "white",
    },
    {
      number: "05",
      title: "Sustainable Design",
      description: "Dynamic and incremental design and growth.",
      section: "black",
    },
    {
      number: "06",
      title: "Impacts Assessment",
      description:
        "Measure the positive economic, societal, infrastructure, and natural impacts.",
      section: "black",
    },
    {
      number: "07",
      title: "Development",
      description:
        "Stakeholder involvement, regulation, planning, mitigation, staging, and building.",
      section: "black",
    },
    {
      number: "08",
      title: "Operations",
      description: "Develop operations, monitoring, risk, and contingency plans.",
      section: "black",
    },
  ];

  const gotoDemoPage = () => {
    scrollToTop();
    navigate('/book-demo');
    document.title = 'Book a Demo - Walkspan';
  };

  const Measurements = () => {
      const settings = {
        infinite: false,
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
      };
  
      const handleArrowClick = (index, type) => {
        if (
          (type === 'plus' && measureTab !== 9) ||
          (type === 'minus' && measureTab !== 0)
        ) {
          debounce(setMeasureTab(index), 2000);
        }
      };
  
      useEffect(() => {
        if (measureSliderRef) {
          measureSliderRef.slickGoTo(measureTab);
        }
      }, [measureTab]);
  
      return (
        <div className='measurements-container'>
          <div className='max-w-screen-lg relative'>
            <h1 className='text-xl md:text-[28px] uppercase font-medium mb-4 text-center'>What We Measure</h1>
            <Slider
              ref={(slider) => {
                measureSliderRef = slider;
              }}
              {...settings}
            >
              {measureSlideData.map((tab, index) => (
                <div key={index} className='!flex justify-between items-start flex-col md:flex-row py-8'>
                  <div className='relative flex flex-col text-left gap-4'>
                    <div className='-z-2 absolute text-gray-300 font-bold text-6xl md:text-8xl number 2xs:-top-[8px] md:top-0'>0{index+1}</div>
                    <div className='2xs:mt-7 md:mt-9 z-10'>
                      <div className='uppercase font-bold 2xs:text-4xl md:text-5xl'>{tab.title}</div>
                      <div className='text-[14px] 2xs:text-3xl md:text-2xl font-medium max-w-[350px]'>{tab.subtitle}</div>
                    </div>
                    <div className='italic font-medium description text-[16px]'>{tab.description}</div>
                  </div>
                  <img
                    src={tab.img}
                    className='w-[450px] h-[400px] object-contain 2xs:mt-2 md:m-0'
                    alt={`measure-img-${index+1}`}
                  />
                </div>
              ))}
            </Slider>
            <div className='arrow-wrapper'>
              <MeasureArrow
                className='arrow'
                onClick={() => handleArrowClick(measureTab - 1, 'minus')}
              />
              <MeasureArrow
                className='arrow -scale-x-100'
                onClick={() => handleArrowClick(measureTab + 1, 'plus')}
              />
            </div>
          </div>
        </div>
      );
    };

  return (
    <div className="bg-gray-100">
      <div className='bg-[#211F1F]'>
        <div className="text-white pt-16 text-center">
            <p className="text-lg max-w-screen-md mx-auto mb-8">
            A one-mile radius or a one square-mile urban area where the experience of walking and other soft mobility transportation modes are heightened by the availability of <span className="font-bold">lifestyle essentials</span> and the <span className="font-bold">quality</span> of the public realm.
            </p>
        </div>

        <div className='w-full bg-[#211F1F] lg:py-16'>
          <div className='relative mx-auto max-w-6xl overflow-hidden'>
            <img src={isMobile ? WalkingTimeDistance2 : WalkingTimeDistance} className='walking-td max-w-6xl mx-auto' />
            <div className='absolute 2xs:top-8 md:top-[27rem] 2xs:right-1/2 md:right-8 transform 2xs:translate-x-1/2 md:translate-x-0 2xs:-translate-y-0 md:-translate-y-1/2 text-white p-4 rounded-lg max-w-full lg:max-w-[40%] 2xs:w-full md:w-[unset]'>
              <h2 className='2xs:text-2xl md:text-4xl font-medium mb-6 shadow-lg uppercase text-center'>Walking <br/> Time and Distance</h2>
              <span className='text-[14px] md:text-xl leading-none lg:leading-relaxed shadow-md 2xs:text-center md:text-justify'>Walkspan is the only AI-driven intelligence platform that provides a comprehensive overview of a neighborhood and the ability to examine each of the factors individually and within walkable distances from specific addresses.</span>
            </div>
          </div>
        </div>

        <div className="py-12 text-white mt-4">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 px-4">
            <div className="text-center">
                <h2 className="mb-4 text-lg font-medium">NEIGHBORHOOD GEMS</h2>
                <img
                src={ServiceGem}
                alt="Neighborhood Gems"
                className="w-full"
                />
            </div>
            <div className="text-center">
                <h2 className="mb-4 text-lg font-medium">NEIGHBORHOOD CHARACTER</h2>
                <img
                src={ServiceCharacter}
                alt="Neighborhood Character"
                className="w-full"
                />
            </div>
            </div>
            <div className="text-center mt-8">
            <button className="landing-view-btn" onClick={() => gotoDemoPage()}>
                Book a Demo
            </button>
          </div>
        </div>
      </div>

      {Measurements()}

      {/* Planning Sections */}
      <div className="py-16 bg-white text-center">
        <h2 className="text-2xl md:text-3xl font-medium mb-8">PLANNING THE 20-MINUTE CITY</h2>
        <div className="max-w-3xl mx-auto flex flex-col gap-8 px-4">
          {planningSteps
            .filter((step) => step.section === "white")
            .map((step, index) => (
            <div
                key={index}
                className={`flex flex-col md:flex-row items-center ${
                index % 2 === 0 ? "md:justify-start" : "md:justify-end"
                }`}
            >
                {/* Content Section */}
                <div
                    className={`flex flex-col md:w-1/2 ${
                        index % 2 === 0 ? "items-start text-left" : "items-end text-right"
                    }`}
                    >
                    <h3 className="text-6xl text-gray-300 font-bold">{step.number}</h3>
                    <h4 className="text-3xl font-bold">{step.title}</h4>
                    <p className="text-gray-600 mt-2">{step.description}</p>
                </div>
            </div>
            ))}
        </div>
      </div>
      <div className="py-16 bg-black text-white text-center planning-gradient">
        <div className="max-w-3xl mx-auto flex flex-col gap-8 px-4">
            {planningSteps
            .filter((step) => step.section === "black")
            .map((step, index) => (
                <div
                key={index}
                className={`flex flex-col md:flex-row items-center ${
                    index % 2 === 0 ? "md:justify-start" : "md:justify-end"
                }`}
                >
                {/* Content Section */}
                <div
                    className={`flex flex-col md:w-1/2 ${
                    index % 2 === 0
                        ? "items-start text-left"
                        : "items-end text-right"
                    }`}
                >
                    <h3 className="text-6xl text-[#787878] font-bold">{step.number}</h3>
                    <h4 className="text-3xl font-bold">{step.title}</h4>
                    <p className="text-gray-300 mt-2">{step.description}</p>
                </div>
                </div>
            ))}
          </div>
        </div>
    </div>
  );
};

export default TwentyMinuteCity;
